<div id="web">
  <div id="webHeader" [class.noNavigation] = "!navigation">
    <div class="maxWebContent">
      <wbpHeader></wbpHeader>
    </div>
  </div>

  <app-mobil-ladeanzeige *ngIf="loadingOverlay"></app-mobil-ladeanzeige>
  <div
    id="webDialog"
    class="maxWebContent"
    [class.hideContent] = "loadingOverlay"
    [class.showContent] = "!loadingOverlay"
    >
    <div
      id="webContent"
      [class.noNavigation] = "!navigation">
      <web-mitteilungen></web-mitteilungen>
      <router-outlet></router-outlet>
    </div>
    <div
      id="webSeitenleiste"
      *ngIf="seitenleiste">
      <app-seitenleiste></app-seitenleiste>
    </div>
  </div>
  <div id="webFooter" [class.noNavigation] = "!navigation">
    <div class="maxWebContent">
      <wbpFooter></wbpFooter>
    </div>
  </div>
</div>
